module.exports = __webpack_public_path__ + "media/images/pattern_bg-476b55da.jpg";